import React from 'react'
import {useTimer} from '../../hooks/use-timer'
import {ColorPicker, CountdownTimer as CountdownTimerType} from '../../types/cms'
import {Flex, Text} from '../../vanilla'

interface TimerProps {
  color: ColorPicker
  date: string
}


const Timer = ({color, date}: TimerProps) => {
  const shouldPrependZeros = true
  const {hours, minutes, seconds} = useTimer(date, shouldPrependZeros)

  return (
    <Text
      as="span"
      style={{color: color?.color}}
      variant="text4"
    >{`${hours}h:${minutes}m:${seconds}s`}</Text>
  )
}

interface CountdownTimerProps {
  content: CountdownTimerType
}

export const CountdownTimer = ({content}: CountdownTimerProps) => {
  return (
    <Flex
      style={{backgroundColor: content?.countdownColor?.color || '#fff'}}
      justify="center"
      align="center"
      paddingY="16px"
      paddingX="12px"
    >
      <Text variant="text4" style={{color: content?.textColor?.color}}>
        {content?.text} <Timer color={content?.textColor} date={content?.countdownDate} />
      </Text>
    </Flex>
  )
}
